import React from "react";

export const AccountDetailContext = React.createContext(null);

export const useAccountDetailContext = () => {
  const context = React.useContext(AccountDetailContext);

  if (!context) throw new Error("Account Detail Context not provided!");

  return context;
};
